<template>
  <div class="base">
    <inside-header color="#fff" title="修改密码" />
    <div class="main">
      <a-alert message="您好，您正在修改密码。密码需要符合复杂性要求：需要大写字母，小写字母和数字的两种或两种以上，长度八位以上。密码修改完成后将退出登录" banner />
      <a-form :form="passForm" :label-col="{ span: 5 }" style="margin-top: 40px;" :wrapper-col="{ span: 18 }"
        @submit="handleSubmitChangePass">
        <a-form-item label="新密码">
          <a-input-password v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: '请输入您的密码',
                },
                {
                  pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/,
                  message: '需要大写字母，小写字母和数字的两种或两种以上，长度八位以上'
                },
                {
                  validator: validateToNextPassword,
                }
              ],
            },
          ]" placeholder="输入新密码" />
        </a-form-item>
        <a-form-item label="再次输入">
          <a-input-password v-decorator="[
            'confirm',
            {
              rules: [
                {
                  required: true,
                  message: '请重复输入您的密码',
                },
                {
                  validator: compareToFirstPassword,
                },
              ],
            },
          ]" placeholder="再次输入新密码" type="password" @blur="handleConfirmBlur" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" :loading="state.changePasswordBtn" html-type="submit">
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import { mapActions } from 'vuex'

export default {
  name: 'UserSetting',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: false,
      // 验证码
      captcha_key: '',
      captcha_img_str: '',
      // 逻辑
      state: {
        changePasswordBtn: false
      },
      // 密码相关
      passForm: this.$form.createForm(this, { name: 'pass-form' })
    }
  },
  created() {
  },
  methods: {
    ...mapActions(['UserLogout']),
    onSubmit(values) {
      console.log('submit', values)
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    validateToNextPassword(rule, value, callback) {
      const passForm = this.passForm
      if (value && this.confirmDirty) {
        passForm.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    compareToFirstPassword(rule, value, callback) {
      const passForm = this.passForm
      if (value && value !== passForm.getFieldValue('password')) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    },
    handleSubmitChangePass(e) {
      const {
        UserLogout
      } = this
      // 提交新密码到后台
      e.preventDefault()
      this.passForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.state.changePasswordBtn = true
          this.$http({
            url: '/index/user/changePass',
            method: 'post',
            data: {
              new_password: values.password
            }
          }).then(res => {
            if (res.status === 'success') {
              this.state.changePasswordBtn = false
              this.$toast.success('密码修改成功，请重新登录')
              this.visiblePasswordDrawer = false
              // 密码修改后需要重新登录，清空token并刷新当前页面
              UserLogout(values).finally(() => {
                // 刷新当前页面
                setTimeout(function () {
                  location.reload()
                }, 1000)
              })
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
  }

  .logout-btn {
    margin-top: 20px;
    .van-button__content {
      span {
        color: #333333;
      }
    }
  }

  .submit-area {
    margin-top: 35px;
    .submit-btn {
      border-radius: 10px;
    }
  }
</style>
